<template>
    <div class="page-content margin-top-10">
        <div class="content mobile-display">
            <carousel :autoplay="false" :nav="false" :items="3" :margin="15" :dots=false>
                <SliderAbout
                    link="about-generali"
                    image="home/quick_action/about_generali.png"/>
                <SliderAbout
                    link="life-insurance-opportunity"
                    image="home/quick_action/life_insurance_opportunity.png"/>
                <SliderAbout
                    link="perks"
                    image="home/quick_action/my_potential_income.png"/>
                <SliderAbout
                    link="explore-the-world"
                    image="home/quick_action/explore_the_world.png"/>
                <SliderAbout
                    link="awards"
                    image="home/quick_action/awards_recogition.png"/>
                <SliderAbout
                    link="success-roadmap"
                    image="home/quick_action/my_success_roadmap.png"/>
                <SliderAbout
                    link="bussiness-opportunity-support-scheme"
                    image="home/quick_action/business_opportunity_support_scheme.png"/>
                <SliderAbout
                    link="talent-profiling-guide"
                    image="home/quick_action/my_talent_profiling_guide.png"/>
                <SliderAbout
                    link="career-lifestyle-survey"
                    image="home/quick_action/career_lifestyle_survey_guide.png"/>
            </carousel>
        </div>
        <div class="content ipad-display">
            <carousel :autoplay="false" :nav="false" :items="4" :margin="15" :dots=false>
            <SliderAbout
                    link="about-generali"
                    image="home/quick_action/iPad/about_generali.png"/>
                <SliderAbout
                    link="life-insurance-opportunity"
                    image="home/quick_action/iPad/life_insurance_opportunity.png"/>
                <SliderAbout
                    link="perks"
                    image="home/quick_action/iPad/my_potential_income.png"/>
                <SliderAbout
                    link="explore-the-world"
                    image="home/quick_action/iPad/explore_the_world.png"/>
                <SliderAbout
                    link="awards"
                    image="home/quick_action/iPad/awards_recogition.png"/>
                <SliderAbout
                    link="success-roadmap"
                    image="home/quick_action/iPad/my_success_roadmap.png"/>
                <SliderAbout
                    link="bussiness-opportunity-support-scheme"
                    image="home/quick_action/iPad/business_opportunity_support_scheme.png"/>
                <SliderAbout
                    link="talent-profiling-guide"
                    image="home/quick_action/iPad/my_talent_profiling_guide.png"/>
                <SliderAbout
                    link="career-lifestyle-survey"
                    image="home/quick_action/iPad/career_lifestyle_survey_guide.png"/>
            </carousel>
        </div>

        <div class="content bottom-0 left-text">
            <p class="home-title bottom-0">Generali Convention</p>
            <p class="home-desc bottom-20 color-white">
                Best Convention Destination
            </p>
           <span class="toggle-icon"><img v-bind:src="'images/mpower-new/home/generali_convention/icon.png'"></span>
        </div>
        <div class="content mobile-display">
            <carousel :autoplay="false" :nav="false" :items="2" :margin="15" :dots=false>
                <SliderSingle
                    title="Seoul"
                    title2="KOREA"
                    image="home/generali_convention/korea.png"
                    description="Korea"
                    modal="korea-modal"
                    menu="menu-korea"
                    positionSlide2="240px"
                    image2="home/generali_convention/korea.png"
                    description1="Generali Star Convention"
                    description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
                    link="korea"

                    y1y2agentspvi="138,000"
                    agentspvi="168,000"
                    leaderpspvi="208,000"
                    directunitpvi="504,000"
                    grouppvi="1,008,000"

                    badge="explore_the_world/logo/korea.png"
                    bannerBadge="korea-badge.png"
                    />
                <SliderSingle
                    title="USA"
                    title2="LOS ANGELES & LAS VEGAS"
                    image="home/generali_convention/usa.png"
                    description="USA"
                    modal="usa-modal"
                    menu="menu-usa"
                    positionSlide2="145px"
                    image2="home/generali_convention/usa.png"
                    description1="Generali Elite Convention"
                    description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
                    link="usa"

                    y1y2agentspvi="288,000"
                    agentspvi="348,000"
                    leaderpspvi="428,000"
                    directunitpvi="1,044,000"
                    grouppvi="2,088,000"

                    badge="explore_the_world/logo/usa.png"
                    bannerBadge="usa-badge.png"
                    />
                <SliderSingle
                    title="Bangkok"
                    title2="Thailand"
                    image="home/generali_convention/thailand.png"
                    description="Thailand"
                    modal="thailand-modal"
                    menu="menu-thailand"
                    positionSlide2="145px"
                    image2="home/generali_convention/thailand.png"
                    description1="Generali Rising Star"
                    description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
                    link="thailand"

                    y1y2agentspvi=""
                    agentspvi=""
                    leaderpspvi=""
                    directunitpvi=""
                    grouppvi=""

                    badge="explore_the_world/logo/thailand.png"
                    bannerBadge="thailand-badge.png"
                    />
            </carousel>
        </div>
        <div class="content ipad-display">
            <carousel :autoplay="false" :nav="false" :items="2" :margin="15" :dots=false>
                <SliderSingle
                    title="Seoul"
                    title2="KOREA"
                    image="home/generali_convention/korea.png"
                    description="Korea"
                    modal="korea-modal"
                    menu="menu-korea"
                    positionSlide2="240px"
                    image2="home/generali_convention/korea.png"
                    description1="Generali Star Convention"
                    description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
                    link="korea"

                    y1y2agentspvi="138,000"
                    agentspvi="168,000"
                    leaderpspvi="208,000"
                    directunitpvi="504,000"
                    grouppvi="1,008,000"

                    badge="explore_the_world/logo/korea.png"
                    bannerBadge="korea-badge.png"
                    />
                <SliderSingle
                    title="USA"
                    title2="LOS ANGELES & LAS VEGAS"
                    image="home/generali_convention/usa.png"
                    description="USA"
                    modal="usa-modal"
                    menu="menu-usa"
                    positionSlide2="145px"
                    image2="home/generali_convention/usa.png"
                    description1="Generali Elite Convention"
                    description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
                    link="usa"

                    y1y2agentspvi="288,000"
                    agentspvi="348,000"
                    leaderpspvi="428,000"
                    directunitpvi="1,044,000"
                    grouppvi="2,088,000"

                    badge="explore_the_world/logo/usa.png"
                    bannerBadge="usa-badge.png"
                    />
                <SliderSingle
                    title="Bangkok"
                    title2="Thailand"
                    image="home/generali_convention/thailand.png"
                    description="Thailand"
                    modal="thailand-modal"
                    menu="menu-thailand"
                    positionSlide2="145px"
                    image2="home/generali_convention/thailand.png"
                    description1="Generali Rising Star"
                    description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
                    link="thailand"

                    y1y2agentspvi=""
                    agentspvi=""
                    leaderpspvi=""
                    directunitpvi=""
                    grouppvi=""

                    badge="explore_the_world/logo/thailand.png"
                    bannerBadge="thailand-badge.png"
                    />
            </carousel>
        </div>
        <ExploreBannerContent
        video="explore_the_world/video/Generali Star Convention - Korea.mp4"
            modal="korea-modal"
            title="Seoul"
            title1="Korea"
            menu="menu-korea"
            positionSlide2="240px"
            image="korea.png"
            description1="Generali Star Convention"
            description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
            description3=""
            link="korea"
            
            y1y2agentspvi="138,000"
            agentspvi="168,000"
            leaderpspvi="208,000"
            directunitpvi="504,000"
            grouppvi="1,008,000"
            
            badge="explore_the_world/logo/korea.png"
            bannerBadge="korea-badge.png"
        />
        <ExploreBannerContent
            video="explore_the_world/video/Generali Elite Convention - USA.mp4"
            modal="usa-modal"
            title="USA"
            title1="Los Angeles & Las Vegas"
            menu="menu-usa"
            positionSlide2="145px"
            image="usa.png"
            description1="Generali Elite Convention"
            description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
            description3=""
            link="usa"

            y1y2agentspvi="288,000"
            agentspvi="348,000"
            leaderpspvi="428,000"
            directunitpvi="1,044,000"
            grouppvi="2,088,000"

            badge="explore_the_world/logo/usa.png"
            bannerBadge="usa-badge.png"
        />
        <ExploreBannerContent
            video="explore_the_world/video/Generali RisingStar Convention - Thailand.mp4"
            modal="thailand-modal"
            title="Bangkok"
            title1="Thailand"
            menu="menu-thailand"
            positionSlide2="145px"
            image="thailand.png"
            description1="Generali Rising Star"
            description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
            description3=""
            link="thailand"

            y1y2agentspvi=""
            agentspvi=""
            leaderpspvi=""
            directunitpvi=""
            grouppvi=""

            badge="explore_the_world/logo/thailand.png"
            bannerBadge="thailand-badge.png"
        />

        <div class="content bottom-0 left-text">
            <p class="home-title bottom-0">Highlight</p>
            <p class="home-desc bottom-20 color-white">
              &nbsp;
            </p>
            <span class="toggle-icon"><img v-bind:src="'images/mpower-new/home/highlight/icon.png'"></span>
        </div>
        <div class="content mobile-display">
            <carousel :autoplay="false" :nav="false" :items="2" :margin="15" :dots=false>
                <SliderHighlight
                    image="home/highlight/my_talent_profiling_guide.png"
                    link="talent-profiling-guide"
                    back="home"
                />
                <SliderHighlight
                    image="home/highlight/career_lifestyle_survey_guide.png"
                    link="career-lifestyle-survey"
                    back=""
                />
            </carousel>
        </div>
        <div class="content ipad-display">
            <carousel :autoplay="false" :nav="false" :items="4" :margin="15" :dots=false>
                <SliderHighlight
                    image="home/highlight/iPad/my_talent_profiling_guide.png"
                    link="talent-profiling-guide"
                    back="home"
                />
                <SliderHighlight
                    image="home/highlight/iPad/career_lifestyle_survey_guide.png"
                    link="career-lifestyle-survey"
                    back=""
                />
            </carousel>
        </div>
        <div class="divider divider-margins"></div>
    </div>
</template>

<script>
import SliderAbout from '../components/SliderAbout.vue'
import SliderSingle from '../components/SliderSingle.vue'
import SliderHighlight from '../components/SliderHighlight.vue'
import ExploreBannerContent from '../components/ExploreBannerContent.vue'
import carousel from 'vue-owl-carousel'

export default {
  name: 'Home',
  components: {
    SliderAbout,
    SliderSingle,
    SliderHighlight,
    ExploreBannerContent,
    carousel,
  }, 
  mounted(){
      document.querySelector(".header-s").style.display = "block";
      document.querySelector(".header").style.zIndex = "96";
  },
}
</script>
<style scoped>
.home-title{
    font-size: 24px;
    font-family: "HelveticaNeueLTStd-Bd";
    color: #fff;
    line-height: revert;
}

.home-desc{
    font-size: 14px;
    color: #fff;
    font-family: "HelveticaNeueLTStd-Roman";
}
</style>
